import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnComponent, GridModule, RowArgs, SelectableSettings } from '@progress/kendo-angular-grid';
import { v4 as uuidv4 } from 'uuid';
import { CommonModule, NgIf } from '@angular/common';
import { ModalOptions, ModalWrapperComponent } from '../../widgets';
import { TileService } from '../../widgets/services/tile.service';
import { AppToastService } from '../../widgets/services/app-toast.service';
import { SharepointPackageType } from '../models/SharepointPackageType';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-taxonomy-files',
  standalone: true,
  imports: [GridModule, NgIf, CommonModule, FormsModule, ModalWrapperComponent, GridModule],
  templateUrl: './taxonomy-files.component.html',
  styleUrls: ['./taxonomy-files.component.scss']
})
export class TaxonomyFilesComponent {
  @Input() options: ModalOptions = new ModalOptions();
  @Input() params: any[] = [];
  selectedfile: string[] = [];
  termName: string = "";
  termId: string = "";
  files: any[] = [];
  teamFolderIdDetail: string = "";
  showPopUp: boolean = false;
  constructor(private modalService: NgbModal, private service: TileService, private toaster: AppToastService, public activeModal: NgbActiveModal, private elementRef: ElementRef) {
  }
  ngOnInit() {
    (document.getElementById('taxonomy-download') as HTMLElement).style.display = 'block';
    this.options.title = this.setPopupTitle(this.options.title + "");
    var packageType: SharepointPackageType = this.params[1].packageType;
    this.service.getTaxonomyFiles(this.params[0].id.toString(), packageType).then((data) => {
      this.files = this.replaceUnderscore(data);

      (document.getElementById('taxonomy-download') as HTMLElement).style.display = 'none';

    }).catch(() => {
      (document.getElementById('taxonomy-download') as HTMLElement).style.display = 'none';
    });
  }
  onCancel(event: any) {
    this.activeModal.dismiss(event);
  }
  replaceUnderscore(files: any[]) {
    files.forEach(m => {
      m.fileName = m.fileName.replace(/_/g, ' ');
    });
    return files;
  }


  // Saves the streamed archive. A data: URL would hold the whole payload in JS
  // memory again and Chrome caps how large one can be, which is what broke
  // downloads of large packages.
  downloadFile(blob: Blob, filenName: string) {
    const url = URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = filenName;
    downloadLink.click();
    setTimeout(() => URL.revokeObjectURL(url));
  }
  download() {
    if (this.selectedfile.length > 0) {
      (document.getElementById('taxonomy-download') as HTMLElement).style.display = 'block';
      var formData = new FormData();
      var termName = this.params[2].termName;
      formData.append("fileIds", JSON.stringify(this.selectedfile));
      formData.append("termName", termName);
      this.service.downloadTaxonomyFile(formData).then((zip) => {
        this.downloadFile(zip, termName + ".zip");
        (document.getElementById('taxonomy-download') as HTMLElement).style.display = 'none';
        var isCheked = this.elementRef.nativeElement.querySelectorAll('.k-checkbox')[0].checked;
        if (isCheked) {
          this.elementRef.nativeElement.querySelectorAll('.k-checkbox')[0].click();
        }
        else {
          for (let i = 0; i < 2; i++) {
            setTimeout(() => {
              this.elementRef.nativeElement.querySelectorAll('.k-checkbox')[0].click();
            }, 200);
          }
        }
        if (this.selectedfile.length > 0) {
          var obj = {
            id: uuidv4(),
            packageName: termName,
            downloadBy: "",
            downloadDate: Date.now

          }
          this.sdDownloadLog(obj);
        }
      }).catch(() => {
        // Without this the spinner overlay stays up forever on a failed download.
        (document.getElementById('taxonomy-download') as HTMLElement).style.display = 'none';
      });
    }
  }
  sdDownloadLog(model: any) {
    //this.service.saveSDDownloadlog(model).then(data => {

    //})
  }

  clkbox(selectedId: any) {
    if (!this.selectedfile.includes(selectedId)) {
      this.selectedfile.push(selectedId);
    } else {
      this.selectedfile.splice(this.selectedfile.indexOf(selectedId), 1);
    }
  }

  clkboxAll(event: any) {
    var isSeletedAll = event.target.checked;
    if (isSeletedAll) {
      this.elementRef.nativeElement.querySelectorAll('.file-checkbox').forEach((x: any) => x.checked = true);
      this.files.forEach(x => {
        if (x.videoLink == '') {
          this.selectedfile.push(x.fileId);
        }
      })
    } else {
      this.elementRef.nativeElement.querySelectorAll('.file-checkbox').forEach((x: any) => x.checked = false);
      this.selectedfile = [];
    }
  }

  getTeamFolder(event: any) {
    this.termId = this.params[0].id;
    var encodedPackageKey = encodeURIComponent(this.termId).replace(/%/g, "!");
    this.service.getTeamViewFolder(encodedPackageKey).then(data => {
      this.teamFolderIdDetail = data.packageName;
      this.showPopUp = true;
    });
  }
  closePopUp(ev: any) {
    this.showPopUp = false;
  }
  setPopupTitle(key: string) {
    if (key.length > 30)
      return key.substring(0, 30) + ' - Files';
    else
      return key + ' - Files';
  }
}






